import { render, staticRenderFns } from "./brandRemarks.vue?vue&type=template&id=306c620e&scoped=true"
import script from "./brandRemarks.vue?vue&type=script&lang=js"
export * from "./brandRemarks.vue?vue&type=script&lang=js"
import style0 from "./brandRemarks.vue?vue&type=style&index=0&id=306c620e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306c620e",
  null
  
)

export default component.exports